import { render, staticRenderFns } from "./EventNotice.vue?vue&type=template&id=5b6009fa&scoped=true"
import script from "./EventNotice.vue?vue&type=script&lang=js"
export * from "./EventNotice.vue?vue&type=script&lang=js"
import style0 from "./EventNotice.vue?vue&type=style&index=0&id=5b6009fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6009fa",
  null
  
)

export default component.exports